import React, { Fragment } from 'react';
import ServicesSummary from '../ServicesSummary';
import '../loggedOut.css';

const OurServices = () => {
    return (
        <Fragment>
            <div className="logged-out">
                <section className="service-hero scene scene--hero page-hero">
                    <div className="container">
                        <div className="hero-grid">
                            <div className="hero-copy">
                                <h1 className="display-5 mb-3">Our Services</h1>
                                <p className="lead">
                                    Beyond Community Access have a handful of different programs, run by individual staff, who have an interest in that topic! We support staff to bring their passion to work with them and encourage them to build programs based on their interests. As a result, BCA is currently offering 9 programs to its clientele a all truly interest led.
                                    Everything from amazing social programs, to cooking and life skills, and everything in-between. Please take a look at our amazing programs.
                                </p>
                            </div>
                            <div className="hero-media text-center">
                                <div className="image-shell image-shell--hero">
                                    <img
                                        src="/marketing_images/services/top_level.jpg"
                                        alt="Accessible Eats cooking program"
                                        className="img-fluid"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <ServicesSummary />
            </div>
        </Fragment>
    );

}

export default OurServices;
